import { Box, Slider, Stack, Typography } from '@mui/material';

import {
  selectScenarioCapacity,
  setScenarioCapacity,
} from 'state/detourSlices';
import { useAppDispatch, useAppSelector } from 'state/hooks';

import { InfoWalkmeCrumb } from 'features/info_hover/InfoHover';

import styles from './DetourTaskBar.module.css';

export default function SliderCapacity({
  showSlider,
}: {
  showSlider: boolean;
}) {
  const dispatch = useAppDispatch();

  const capacity = useAppSelector(selectScenarioCapacity);

  return (
    <Box className={styles.slider_box}>
      <Typography variant="body2">
        Capacity Open to Traffic <InfoWalkmeCrumb elId="closure-capacity" />
      </Typography>
      <Stack
        className={styles.slider_wrapper}
        sx={{ width: showSlider ? '100%' : 'fit-content' }}
      >
        {showSlider && (
          <Slider
            value={capacity}
            onChange={(ev, value) => {
              return dispatch(setScenarioCapacity(value));
            }}
            max={100}
            min={0}
            step={10}
            marks
            valueLabelDisplay="off"
            className={styles.slider}
          />
        )}
        <Box className={styles.capacityLabel}>
          <Typography variant="caption">{capacity}%</Typography>
        </Box>
      </Stack>
    </Box>
  );
}
